export default __webpack_public_path__ + "static/media/profilephoto.91562263.png";